import { render, staticRenderFns } from "./Wmkc.vue?vue&type=template&id=84d414b6"
import script from "./Wmkc.vue?vue&type=script&lang=js"
export * from "./Wmkc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports